import { enqueueSnackbar } from "notistack";

export const createNotification = ({ type, message }) => {
  return enqueueSnackbar(message, { variant: type });
};

